// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/customPage/Headline/Headline.scss
// module id = 4702
// module chunks = 50